export const name = 'PdfPresetUploadController';
export default function PdfPresetUploadController($mdDialog, $scope, $log, presetsService, L10NFilter, errorDialogOpen) {
    //noinspection BadExpressionStatementJS
    'ngInject';

    var vm = this;

    vm.uploadPdfPreset = uploadPdfPreset;
    vm.selectedFile = {};
    vm.fileSelected = fileSelected;
    vm.onFileSelect = onFileSelect;
    vm.showDropArea = true;
    vm.showProgressBar = false;
    vm.uploadProgress = 0;
    vm.uploadProgressCallback = uploadProgressCallback;
    vm.knownProgress = false;
    vm.loadInProgress = false;
    vm.isFileSelectedFlag = false;
    vm.cancel = cancel;
    vm.uploadContoller = {cancel:false};
    vm.selectedFileName = '';
    vm.closeDialogFromOutsideHelperObject.RegisterOnCloseCallback(closeCalledFromOutside);

    if(vm.fileUploadProps){
      vm.selectedFile = vm.fileUploadProps.fileSelected;
      vm.selectedFileName = vm.fileUploadProps.fileSelected.name;
      uploadPdfPreset();
    }

    function closeCalledFromOutside(){
        $mdDialog.cancel();
    }

    function fileSelected(selectedFile){
        vm.selectedFile = selectedFile;
    }

    function onFileSelect($files){
        vm.isFileSelectedFlag = true;
        fileSelected($files[0]);
    }

    function uploadProgressCallback(uploadReportPercentage, pdfPresetId = null){
        if(pdfPresetId){
            vm.pdfPresetId = pdfPresetId;
        }

        if(uploadReportPercentage){
            vm.uploadProgress = uploadReportPercentage;
            vm.knownProgress = true;
            if(uploadReportPercentage === 100){
                vm.knownProgress = false;
            }
            $scope.$apply();
        }
    }

    function cancel(){
        vm.uploadContoller.cancel = true;

        if(vm.pdfPresetId){
          presetsService.deletePdfPreset(vm.pdfPresetId);
        }

        $mdDialog.cancel();
    }

    function uploadPdfPreset() {
      let functionName='PdfPresetUploadController.uploadTemplate';
      $log.info(angular.toJson({action:'function called', functionName:functionName, fileName:vm.selectedFile.name}));

      vm.showDropArea = false;
      vm.showProgressBar = true;
      vm.loadInProgress = true;

      presetsService.uploadPdfPreset(vm.selectedFile, uploadProgressCallback, vm.uploadContoller).then(
        function (postUploadTemplate) {
          $log.info(angular.toJson({action:'file uploaded successfully', functionName:functionName}));

          $mdDialog.hide(postUploadTemplate);
        }, function(status) {
          $log.info(angular.toJson({action:'error uploading file', functionName:functionName}));
          $mdDialog.cancel();

          errorDialogOpen.openErrorDialog(status);

        });
    }
}
